import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AuthService} from '../auth/AuthService';
import {Router} from '@angular/router';
import {iClient} from '../Model/ClientModel';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class ProviderService {
  userData = new BehaviorSubject<any>(null);
  private httpOptions: any;
  token:any
  constructor(private httpClient: HttpClient,
              private authService: AuthService,
              private router: Router) {
    // console.log(this.userData);
  }


  providerRegistration(provider?: any): Observable<any> {
    return this.authService.post(`${environment.userService}provider`, provider);
  }

  getAllProviders(params?:any): Observable<any> {
    return this.authService.getP(`${environment.userService}provider`, params);
  }
  // getAllPateint(params?:any): Observable<any> {
  //   return this.authService.getP(`${'registration-dev/client/all'}`, params);
  // }

  deleteProvider(params?:any): Observable<any> {
    return this.authService.delete(`${environment.userService}provider`, params);
  }

  getProviderDetails(params?:any): Observable<any> {
    return this.authService.getP(`${environment.userService}provider`, params);
  }

  updateProvider(body: any, params?:any): Observable<any> {
    return this.authService.put(`${environment.userService}provider`,body, params);
  }

  staffRegistration(staff?: any): Observable<any> {
    return this.authService.post(`${environment.userService}staff`, staff);
  }
  updateStaff(body: any, params?:any): Observable<any> {
    return this.authService.put(`${environment.userService}staff`,body, params);
  }

  getStaffDetails(params?:any): Observable<any> {
    return this.authService.getP(`${environment.userService}staff`, params);
  }

  getProvidersByOfficeId(params?:any): Observable<any> {
    return this.authService.getP(`${environment.patientService}office`, params);
  }

  getAllOffice(params?:any): Observable<any> {
    return this.authService.getP(`${environment.patientService}office`, params);
  }

}
